import { defineMessages } from "react-intl";
import { Channel } from "../../contract/pam.js";
const localizedChannel = defineMessages({
  [Channel.P2P]: {
    id: "UserProfileFilters_P2P",
    defaultMessage: "P2P"
  },
  [Channel.Official]: {
    id: "UserProfileFilters_OFFICIAL",
    defaultMessage: "Official"
  },
  [Channel.None]: {
    id: "UserProfileFilters_NONE",
    defaultMessage: "None"
  }
});
export {
  localizedChannel
};
//# sourceMappingURL=channel.js.map
